import { PartnerContactColumn, PartnerContactData } from "./types";

export { partnerStatusColors } from "../helpers";

// PARTNER is the FK filter key, not a column — the table renders the linked
// partnerName so the column id matches the backend sort/group/filter field.
export const partnerContactColumnKeys = Object.values(
  PartnerContactColumn
).filter((key) => key !== PartnerContactColumn.PARTNER);

export const getPartnerContactFullName = (
  contact: Pick<PartnerContactData, "firstName" | "lastName">
): string =>
  [contact.firstName, contact.lastName]
    .filter(Boolean)
    .join(" ")
    .trim()
    .replace(/\s+/g, " ");

export const partnerContactsSortByOptions = [
  PartnerContactColumn.FULL_NAME,
  PartnerContactColumn.STATUS,
  PartnerContactColumn.CREATED_AT
];

// Group By offers every column a groupable filter reaches; the partner is filtered only
// as the page's scope, so it has no such filter.
export const partnerContactsGroupByOptions = [PartnerContactColumn.PARTNER_NAME];
